<!--<nav class="navbar navbar-expand-lg navbar-light bg-light ">
  <a routerLink="/videogame-edit" routerLinkActive="active" class="navbar-brand " *ngIf="isUserLoggedIn()">Add New Videogame</a>
  <a routerLink="/videogame-list" routerLinkActive="active" class="navbar-brand">Videogame Catalog</a>
  <a routerLink="" class="navbar-brand login-padding" *ngIf="!isUserLoggedIn()" (click)="login()">Login</a>
  <a routerLink="" class="navbar-brand login-padding" *ngIf="isUserLoggedIn()" (click)="logout()">Logout</a>
</nav>-->
<router-outlet>


  <ng-http-loader [backgroundColor]="'#ff0000'"
                  [debounceDelay]="100"
                  [opacity]=".6"
                  [spinner]="spinkit.skWave">
  </ng-http-loader>

</router-outlet>
